import {Controller} from "stimulus"

export default class extends Controller {
  static targets = [ "name", "address" ]

  initialize() {
  }

  connect() {
    const elements = document.querySelectorAll("[id$=field_job]");
    if (elements.length) {
      const formField = elements[0];
      if (formField) {
        formField.value = this.nameTarget.dataset.id + ": " + this.nameTarget.textContent;
      }
    }
  }
}
